import type { Modification, ModificationsList, Modifier } from '../../types';

/**
 * Returns a function to compute changes for a list of additions compared to the active modifications.
 */
export function createModifiersFactory(activeModifications: ModificationsList) {
  return (modification: Modification) => {
    const { id } = modification;

    const modificationToCompare = activeModifications.find(findModificationById(id)); // prettier-ignore
    const changesNumber = getModificationQuantitiesDifference(modification, modificationToCompare); // prettier-ignore
    const changesList = Array.from<Modification>({ length: changesNumber }).fill(modification); // prettier-ignore

    return changesList.map(generateModifier);
  };
}

// ─────────────────────────────────────────────────────────────────────────────

function generateModifier(modification: Modification): Modifier | null {
  if (!modification.ingredient) return null;

  const {
    ingredient,
    additionCost,
    removalCost,
    substitutionCost,
    subKind,
    modificationGroupId,
    modificationGroupRole,
  } = modification;

  const { id: ingredientId } = ingredient;

  return {
    ingredientId,
    additionCost,
    removalCost,
    substitutionCost,
    subKind,
    modificationGroupId,
    modificationGroupRole,
  };
}

function getModificationQuantitiesDifference(
  modification: Modification,
  modificationToCompare: Modification | undefined,
) {
  return modification.quantity - (modificationToCompare?.quantity ?? 0);
}

function findModificationById(modificationId: string) {
  return (activeModification: Modification) => activeModification.id === modificationId;
}
